import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23747 23747"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#fefefe;stroke-width:319.54}.fil0{fill:#000}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2283926895440">
        <path
          id="XMLID_337_"
          d="M12197 11531h10487l-7914-2578-2573-7941z"
          className="fill"
        />
        <path
          id="XMLID_450_"
          d="M11569 11531V1007L8981 8948l-7969 2583z"
          className="fill storke1"
          style={{
            strokeWidth: 319.54,
          }}
        />
        <path
          id="XMLID_451_"
          d="M11569 12159H1063l7914 2578 2592 7998z"
          className="fill storke1"
          style={{
            strokeWidth: 319.54,
          }}
        />
        <path
          id="XMLID_452_"
          d="M12197 12159v10468l2569-7885 7969-2583z"
          className="fill storke1"
          style={{
            strokeWidth: 319.54,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
